import { render } from "./FilterBar.vue?vue&type=template&id=2241f5dc"
import script from "./FilterBar.vue?vue&type=script&lang=js"
export * from "./FilterBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__